module.exports = require("core-js-pure/stable/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor.js
// module id = 607
// module chunks = 0